var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.23293169,3.79518072 L3.23293169,1 C3.23293169,0.44771525 3.68064694,5.45542273e-16 4.23293169,4.4408921e-16 L10.6666663,0 C11.218951,3.89074334e-16 11.6666663,0.44771525 11.6666663,1 L11.6666663,7.43373458 C11.6666663,7.98601933 11.218951,8.43373458 10.6666663,8.43373458 L8.43373458,8.43373458 L8.43373458,11.2289153 C8.43373458,11.7812 7.98601933,12.2289153 7.43373458,12.2289153 L1,12.2289153 C0.44771525,12.2289153 1.00225198e-15,11.7812 4.4408921e-16,11.2289153 L0,4.79518072 C-6.76353751e-17,4.24289597 0.44771525,3.79518072 1,3.79518072 L3.23293169,3.79518072 Z M3.23293169,3.79518072 L3.23293169,7.43373458 C3.23293169,7.98601933 3.68064694,8.43373458 4.23293169,8.43373458 L8.43373458,8.43373458 L8.43373458,4.79518072 C8.43373458,4.24289597 7.98601933,3.79518072 7.43373458,3.79518072 L3.23293169,3.79518072 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenu);
export default __webpack_public_path__ + "static/media/ic_menu.79892f95ef1d564a6031c84c384abb14.svg";
export { ForwardRef as ReactComponent };